/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // LANGUAGE SWITCH
  $(".header__desktop__country .active_country").on("click", function(e) {
    e.stopPropagation();
    $(".header__desktop__country").toggleClass("is-active");
  });

  $(document).on("click", function(e) {
    if (e.originalEvent.originalTarget !== $(".header__desktop__country .countries_wrapper")[0])
    $(".header__desktop__country").removeClass("is-active");
  });


  // SCROLL DOWN ARROW
  const arrow = document.querySelector(".scroll_down_link_arrow");

  if (arrow) {
    arrow.addEventListener("click", () => {
      const srollTop = $(".brick__section").last().offset().top;
      window.scrollTo({ top: srollTop, left: 0, behavior: "smooth" });
    });
  
    document.addEventListener("theme:scroll", () => {
      arrow.classList.toggle("is-hidden", window.pageYOffset > window.innerHeight);
    });
  }
  

  // SECTION CHARACTERISTICS
  const size = Number($(".section-characteristics").data("size"));
  const tabHeaders = $(".section-characteristics .tab_header");
  const tabItems = $(".section-characteristics .tab_item");
  const tabButtons = $(".section-characteristics .btn_change");

  if (tabHeaders) {
    tabHeaders.on("click", function() {
      const index = $(this).data("index");
      const selectedItem = tabItems.filter((i, item) => $(item).data("index") === index);
  
      tabHeaders.removeClass("is-selected");
      $(this).addClass("is-selected");
      tabItems.removeClass("is-selected");
      selectedItem.addClass("is-selected");
    });
  
    tabButtons.on("click", function() {
      let index = $(this).data("index") + $(this).data("add");
      index = index > size ? 1 : index === 0 ? size : index;
  
      const selectedHeader = tabHeaders.filter((i, item) => $(item).data("index") === index);
      const selectedItem = tabItems.filter((i, item) => $(item).data("index") === index);
  
      tabHeaders.removeClass("is-selected");
      selectedHeader.addClass("is-selected");
      tabItems.removeClass("is-selected");
      selectedItem.addClass("is-selected");
    });
  }

  // SECTION SLIDESHOW
  setTimeout(() => {
    const slider = new themeVendor.Flickity($('.slideshow__slider')[0]);
    const sliderButtons = $(".slideshow_header .btn_change");
    const sliderText = $(".slideshow_header .image_text");
    const thumbs = $(".thumbs_wrapper .thumbCustom");

    if (sliderButtons) {
      sliderButtons.on("click", function() {
        if ($(this).data("add") === -1) {
          slider.previous();
        } else {
          slider.next();
        }
      });
  
      thumbs.on("click", function() {
        const index = $(this).data("index");
        slider.selectCell(index);
      });
  
      slider.on('change', function( index ) {
        const selectedText = sliderText.filter((i, item) => $(item).data("index") === index);
        const selectedThumb = thumbs.filter((i, item) => $(item).data("index") === index);
  
        sliderText.removeClass("is-selected");
        selectedText.addClass("is-selected");
        thumbs.removeClass("is-selected");
        selectedThumb.addClass("is-selected");
      });
    }
  }, 1000);


  // SECTION COMPARATOR
  function setOffsetTop() {
    const offsetTop = $(".section-comparator .image_wrapper").height() + 3;
    $(".section-comparator .first_row").css("top", `-${offsetTop}px`);
  }

  $(window).on("resize", setOffsetTop);
  setOffsetTop();

  // FOOTER GEOPRO
  $('.footer__geopro a.open-geopro-popin').click(function(e){
    e.preventDefault();
    $('#geopro-popin').addClass('open');
  });

  $('#geopro-popin .close').click(function(e){
    e.preventDefault();
    $('#geopro-popin').removeClass('open');
  });


  // PRODUCT PAGE
  setTimeout(function() {
    document.querySelectorAll("#template-product .thumb").forEach(function(thumb) {
      thumb.addEventListener("click", function() {
        const t = this.querySelector("a");
        t.click();
      });
    });
  }, 500);  
})();
